// reducers/inventoryDetailReducer.js
import * as actionType from "../constants/actionTypes";

const initialState = {
  inventoryDetail: {},
  loading: false,
  error: null,
  message: "",
};

const inventoryDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.GET_INVENTORY_DETAIL:
      return {
        ...state,
        inventoryDetail: action.payload,
        loading: false,
        error: null,
        message: "Fetched successfully",
      };

    default:
      return state;
  }
};

export default inventoryDetailReducer;
